class RouterConfig {
  stores = '/stores';
  branchDetails = (id: string | number) => `/stores/${id}`;
  productDetails = (storeId: string | number, integrationId: string | number) =>
    `/stores/${storeId}/product/${integrationId}`;
  customListOfBranches = '/cms-list-of-branches';
  accessDenied = 'access-denied';
  joinUs = '/join-us';
  account = '/account';
  wishlist = this.account + '/wishlist';
  profile = this.account + '/profile';
  payment = this.account + '/payment';
  prime = this.account + '/prime';
  contactUs = '/contact-us';
  aboutUs = '/about-us';
  privacyPolicy = '/Privacy-And-Policy';
  termsAndCondition = 'Terms-and-Condition';
  addresses = this.account + '/addresses';
  createAddress = this.addresses + '/create';
  editAddress = (id: string) => this.addresses + `/edit/${id}`;
  order = this.account + '/orders';
  orderDetails = (id: number) => `/order/${id}`;
  paymentSuccessOrder = (id: number | string) => `/order/${id}/PaymentSuccess`;
  cards = '/cards';
  checkout = (id: string | number) => `/checkout/${id}`;
  carts = '/carts';
  digitalCards = '/digital-cards';
  digitalCardDetails = (id: string) => `/digital-cards/${id}`;
  search = '/search';
  mainCheckout = '/checkout';
}

class ApiRouter {
  profile = 'mobile/profile';
  profileEdit = 'mobile/profile';
  payment = 'mobile/payments/cards';
  searchProducts = 'catalog/menu/search';
  cities = 'portal/cities/active-cities';
  stores = 'core/branches/nearby';
  storesIndustries = 'stores/grouped-industries';
  prime = 'mobile/prime/has-active-subscription';
  branch = (id: string) => `mobile/branches/${id}`;
  allProductsForBranch = (id: string) => `catalog/menu/branches/${id}/products`;
  allProductsForBranchWithCategory = (branchId: string, categoryId: string) =>
    `mobile/branches/${branchId}/industries/${categoryId}/products`;
  cmsSections = 'mobile/cms/explore';

  industries = 'catalog/industries';

  // start cart

  allCarts = 'mobile/carts';
  addProductToCart = `mobile/carts`;
  updateProductCart = 'mobile/carts';
  cartById = (id: string) => `mobile/carts/${id}`;
  deleteCart = (id: number | string) => `mobile/carts/${id}`;
  removeProductFromCart = (cartId: number | string, itemId: string) =>
    `mobile/carts/${cartId}/items/${itemId}`;

  // chechout
  checkout = (id: string) => `mobile/carts/${id}/checkout-validation`;
  createOrder = 'mobile/orders/create';
  payOrder = (id: string) => `mobile/orders/${id}/pay`;

  // payment
  removePayment = (id: string) => `mobile/payments/cards/${id}`;
  getAllowdPayments = 'mobile/payments/configurations';
  changeOrderPaymentMethod = (orderId: string) => `mobile/orders/${orderId}/payment-method`;

  // wallet
  getWallet = 'users/wallets';

  // cms
  getContactUs = 'cms/contact-us';
  getGenericContent = 'cms/generic-content';

  // wishlist
  getWishlists = 'mobile/wishlists';
  createWishlist = 'users/wishlists/items/add-or-delete';
  getMyAllWishlist = 'mobile/wishlists/items/minimal';

  // order history

  orderHistory = 'mobile/customer-orders';
  orderDetails = (id: string | number) => `mobile/orders/${id}/details`;

  //addresses
  allAddresses = 'users/addresses';
  addAddress = 'users/addresses';
  deleteAddress = (id: string | number) => `users/addresses/${id}`;
  updateAddress = (id: string | number) => `users/addresses/${id}`;
  addressById = (id: string | number) => `users/addresses/${id}`;

  // copone
  allCopone = 'mobile/my-coupons';

  // cancel Order
  cancelOrder = (id: number) => `mobile/orders/${id}/cancel-with-reason`;

  // reorder Order
  reorder = `orders/reorder`;

  // digital cards
  digitalCards = 'mobile/digital-cards/products';
  digitalCardDetails = (id: string | number) => `mobile/digital-cards/products/${id}`;

  // cities
  getAllCities = 'mobile/cities';

  // gift
  getGift = (token: string) => `mobile/orders/gift/${token}`;

  // POST Gift
  giftInfo = (token: string) => `mobile/orders/gift/${token}`;
}

export const Routes = new RouterConfig();

export const ApiRouts = new ApiRouter();
